import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* AiFunctionCall data store imports */
import * as fromAiFunctionCallState from './ai-function-call.reducer';
import { AiFunctionCallEffects } from './ai-function-call.effects';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    /* data store for AiFunctionCall */
    StoreModule.forFeature(
      fromAiFunctionCallState.featureKey,
      fromAiFunctionCallState.reducer,
      { initialState: fromAiFunctionCallState.initialState }
    ),
    EffectsModule.forFeature([AiFunctionCallEffects])
  ]
})
export class AiFunctionCallDataStoreModule { }
